import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { useResolveGeoCoordinates } from "../../../GoogleMaps/useResolveGeoCoordinates";
import { CountrySelect } from "../../../Locations/CountrySelect";
import Supplier from "../../Supplier";
import { SupplierFormProps } from "../SupplierFormProps";
import { updateCountryCode } from "../updateCountryCode";
import { TextFieldInput } from "../../../Forms/TextFieldInput";
import { GeoCoordinatesAddressTextField } from "../GeoCoordinatesAddressTextField";
import { isNotEmpty } from "../../../Utils/strings";
import { textMaskTextFieldInputProps } from "../../../Forms/formStyles";

export const SupplierAddressForm = ({ disabledFields }: SupplierFormProps) => {
  const { control, setValue, getValues } = useFormContext<Supplier>();

  const { resolveGeoCoordinatesIfAddressIsComplete } = useResolveGeoCoordinates<Supplier>(
    "Street",
    "Zipcode",
    "City",
    "Latitude",
    "Longitude"
  );

  return (
    <BorderedFormGrid>
      {/* FIRST ROW */}
      <Grid item xs={4}>
        <TextFieldInput name="Name" control={control} disabledFields={disabledFields} required />
      </Grid>
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="City"
          control={control}
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("Latitude", fallbackGeoCoordinates.latitude);
            setValue("Longitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("City"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput
          name="CountryCode"
          control={control}
          label="CMMS Country Code"
          disabledFields={disabledFields}
        />
      </Grid>

      {/* SECOND ROW */}
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="Street"
          control={control}
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("Latitude", fallbackGeoCoordinates.latitude);
            setValue("Longitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("Street"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput name="Region" control={control} disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput
          name="AreaCode"
          control={control}
          label="CMMS Area Code"
          disabledFields={disabledFields}
        />
      </Grid>

      {/* THIRD ROW */}
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="Zipcode"
          control={control}
          label="Postcode"
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("Latitude", fallbackGeoCoordinates.latitude);
            setValue("Longitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("Zipcode"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <CountrySelect
          control={control}
          name="CountryID"
          required
          onCountryChanged={(countryId, countries) =>
            setValue("CountryCode", updateCountryCode(countryId, countries))
          }
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput
          name="DefaultLoadingTime"
          control={control}
          label="Default Stop Time"
          placeholder="hh:mm"
          InputProps={textMaskTextFieldInputProps}
          disabledFields={disabledFields}
        />
      </Grid>

      {/* FOURTH ROW */}
      <Grid item xs={4}>
        <TextFieldInput
          name="ZipArea"
          control={control}
          label="Postcode Area"
          disabledFields={disabledFields}
        />
      </Grid>
    </BorderedFormGrid>
  );
};
